import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "expired",
  class: "d-flex align-center flex-column mt-10"
}
const _hoisted_2 = { class: "text-h5 pt-4 pb-4" }
const _hoisted_3 = { class: "font-italic" }
const _hoisted_4 = { id: "buttons" }


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalErrorView',
  setup(__props) {

const supportResource = import.meta.env.VITE_SUPPORT_CONTACT || "your IT support team";

const reloadApp = () => {
  window.location.href = window.location.href.split("?")[0].replace("/error", "");
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_v_icon, {
      color: "error",
      size: "large",
      class: "text-h1 pb-4"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("mdi-alert-circle-outline", -1)
      ]))]),
      _: 1
    }),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-h3 pb-6" }, "Error in application", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-h5 pt-4 pb-4" }, "A system error has occurred. We apologize for this inconvenience.", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createTextVNode(" You can report this issue to ", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(supportResource)) + ".", 1),
      _cache[2] || (_cache[2] = _createTextVNode(". ", -1))
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-h5 pt-4 pb-16" }, "You may also try to reload this application.", -1)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_btn_primary, {
        size: "small",
        onClick: reloadApp
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Reload Application", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})